"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchInstallStatus = fetchInstallStatus;

var InstallStatusAPI = _interopRequireWildcard(require("ui-addon-scriptloader/installStatus/InstallStatusAPI"));

var _InstallStatusStore = _interopRequireDefault(require("ui-addon-scriptloader/installStatus/InstallStatusStore"));

var _InstallStatusConstants = require("ui-addon-scriptloader/installStatus/InstallStatusConstants");

var _defer = _interopRequireDefault(require("q/js/lib/defer"));

var deferred = (0, _defer.default)();

function fetchInstallStatus() {
  var currentStatus = _InstallStatusStore.default.get();

  if (currentStatus === _InstallStatusConstants.PENDING) {
    return deferred.promise;
  }

  _InstallStatusStore.default.set(_InstallStatusConstants.PENDING);

  deferred = (0, _defer.default)();
  InstallStatusAPI.fetchInstallStatus().then(function (newStatus) {
    _InstallStatusStore.default.set(newStatus);

    deferred.resolve({
      success: true
    });
  }).catch(function () {
    deferred.resolve({
      success: false
    });
  });
  return deferred.promise;
}